/* Stienhardt - cert pill inside Meet Your Diamond, LIVE-MIRRORED (2026-06-27)
   Mirrors the live `.sp-stone-cert-stamp` (correct cert authority + report# +
   working "View" link to igi.org/gia.edu) into a `.sp-cert-in-meet` element
   under the `.dp__title`. Mirror (not static clone) so it's never stale/wrong
   across stones. Originals hidden via CSS. Revert = remove file + script. */
(function () {
  'use strict';
  function sync() {
    var title = document.querySelector('.dp__head .dp__title');
    var src = document.querySelector('.product_description--accordion .sp-stone-cert-stamp');
    if (!title || !src) return;
    var clone = title.parentNode.querySelector('.sp-cert-in-meet');
    if (!clone) {
      clone = document.createElement(src.tagName);
      clone.className = (src.className || '') + ' sp-cert-in-meet';
      title.insertAdjacentElement('afterend', clone);
    }
    if (clone.innerHTML !== src.innerHTML) clone.innerHTML = src.innerHTML; // keep live
  }
  var n = 0, iv = setInterval(function () { n++; if (n > 80) clearInterval(iv); sync(); }, 250);
  var mp = document.getElementById('mainproduct');
  if (mp) new MutationObserver(sync).observe(mp, { childList: true, subtree: true });
})();
